import { API_PIVOTHEALTH } from 'core/constants/endpoints'
import { GetExternalPartnerUrlParams, GetExternalPartnerUrlResponse } from './types'

/**
 * Gets the URL for a specific external partner associated with a healthcare agent.
 * @param agentId - The ID of the agent regarding Healthcare Agent
 * @param partnerId - The ID of the external partner
 * @returns A promise that resolves to the partner URL or undefined if not found or error occurs.
 */
export function getExternalPartnerUrl({
  agentId,
  partnerId
}: GetExternalPartnerUrlParams): Promise<GetExternalPartnerUrlResponse | undefined> {
  const uri = `${API_PIVOTHEALTH}/agents/ExternalPartners/getUrl?agent_id=${agentId}&partner_id=${partnerId}`

  return fetch(uri, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json'
    }
  })
    .then(response => {
      if (!response.ok) {
        console.error('[X] Failed to fetch external partner URL:', response.statusText)
        return undefined
      }
      return response.json()
    })
    .catch(error => {
      console.error('[X] Exception fetching external partner URL:', error)
      return undefined
    })
}
